
export enum TopicEventType {
    TOPIC_UPDATED = "topic.topicUpdated",
}